module.exports = __webpack_public_path__ + "static/media/dashboard.7e3d4f0d.svg";